// префикс апи
export const API_BASE_URL = '/api/v1/'
export const prefixAPI = (url, model = '') => API_BASE_URL + model + url
